import React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import PageTitle from "src/Layout/AppMain/PageTitle";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import { getAhrBaseBreadcrumbs } from "src/Pages/AhrCore/routerHelper";
import __ from "src/utils/Translations";
import SubscriptionTable from "src/Pages/Report/Subscriptions/List/table";

export default () => {
  const companyName = useCompanyName();
  const companyId = useCompanyId();

  const editSubUrl = (id) => `/ahr/report/subscriptions/edit/${id}`;

  return (
    <>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <PageTitle
          heading={`Lista aktywnych wysyłek dla firmy ${companyName} (ID: ${companyId})`}
          breadcrumbsHeading={__("Lista aktywnych wysyłek")}
          pushToHistory
          breadcrumbs={[
            ...getAhrBaseBreadcrumbs(companyName),
            { title: __("Raporty"), link: "/ahr/report" },
          ]}
        />
        <SubscriptionTable
          selectCompany={companyId}
          editSubUrl={editSubUrl}
          isAhr
        />
      </CSSTransitionGroup>
    </>
  );
};
